module.exports = __webpack_public_path__ + "static/media/6.f5ab772f.gif";


//////////////////
// WEBPACK FOOTER
// ./src/images/gifshop/gifs/6.gif
// module id = 247
// module chunks = 0